// import { useNavigate } from "react-router";
// import { useState } from "react";
// import ContactType from "./contactInterface"

// const Contact = () => {

//     const [user, setUser] = useState<ContactType>({
//         name: "",
//         email: "",
//         phone: "",
//         description: ""
//     });

//     const navigate = useNavigate();
//     const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
//         setUser({ ...user, [e.target.name]: e.target.value });
//     }

//     const handledescription = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
//         setUser({ ...user, [e.target.name]: e.target.value });
//     }


//     const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
//         e.preventDefault();
//         try {
//             const response = await fetch(
//                 `${process.env.React_App_DYO_CHEF_ContactUs_URL}`,
//                 {
//                     method: "POST",
//                     body: JSON.stringify(user),
//                     headers: {
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );
//             const respData = await response.json();
//             console.log("data", respData);
//             navigate('/');
//         } catch (error) {
//             console.log(error);
//         }
//     }

//     return (
//         <>

//             <div className="getway-wrapper">
//                 <div className="getway-inner">
//                     <div className="getway-inner-items" >
//                         <h2> Welcome to DYO <span> CHEF</span> </h2>
//                         <div className="mt-5 mb-4">
//                             <strong className="fs-5">Contact US</strong>
//                         </div>
//                         <form className="d-flex flex-column gap-4" onSubmit={handleSubmit}>

//                             <div className="form-group">
//                                 <label className="form-label fw-medium"> Name </label>
//                                 <input className="form-control form-input" type="text" placeholder=" Enter your full name" name="name" value={user.name} onChange={handleChange} />
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label fw-medium"> Email </label>
//                                 <input className="form-control form-input" type="text" placeholder=" Enter your full name" name="email" value={user.email} onChange={handleChange} />
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label fw-medium"> Phone </label>
//                                 <input className="form-control form-input" type="text" placeholder=" Enter your full name" name="phone" value={user.phone} onChange={handleChange} />
//                             </div>

//                             <div className="form-group">
//                                 <textarea className="form-control form-input" id="exampleFormControlTextarea1" placeholder="Please Write your massage in details" name="description" value={user.description} onChange={handledescription}></textarea>
//                             </div>

//                             <button className="btn btn-rounded btn-dyo-primary "> Submit </button>

//                         </form>
//                     </div>

//                 </div>
//             </div>

//         </>
//     )
// }

// export default Contact;


import { useNavigate } from "react-router";
import { useState } from "react";
import ContactType from "./contactInterface";

interface ErrorType {
  name?: string;
  email?: string;
  phone?: string;
  description?: string;
  api?: string;
}

const Contact = () => {
  const [user, setUser] = useState<ContactType>({
    name: "",
    email: "",
    phone: "",
    description: "",
  });

  const [errors, setErrors] = useState<ErrorType>({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handledescription = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ): void => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const newErrors: ErrorType = {};

    if (!user.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!user.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!user.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(user.phone)) {
      newErrors.phone = "Phone must be 10 digits";
    }

    if (!user.description.trim()) {
      newErrors.description = "Message is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    setErrors({});

    try {
      const response = await fetch(
        `${process.env.React_App_DYO_CHEF_ContactUs_URL}`,
        {
          method: "POST",
          body: JSON.stringify(user),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong!");
      }

      const respData = await response.json();
      console.log("data", respData);
      navigate("/");
    } catch (error: any) {
      console.error("API Error:", error.message);
      setErrors({ api: error.message || "Unexpected error occurred." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="getway-wrapper">
      <div className="getway-inner">
        <div className="getway-inner-items">
          <h2>
            Welcome to DYO <span>CHEF</span>
          </h2>
          <div className="mt-5 mb-4">
            <strong className="fs-5">Contact US</strong>
          </div>
          <form
            className="d-flex flex-column gap-4"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="form-group">
              <label className="form-label fw-medium">Name</label>
              <input
                className="form-control form-input"
                type="text"
                placeholder="Enter your full name"
                name="name"
                value={user.name}
                onChange={handleChange}
              />
              {errors.name && (
                <span className="text-danger">{errors.name}</span>
              )}
            </div>

            <div className="form-group">
              <label className="form-label fw-medium">Email</label>
              <input
                className="form-control form-input"
                type="text"
                placeholder="Enter your email"
                name="email"
                value={user.email}
                onChange={handleChange}
              />
              {errors.email && (
                <span className="text-danger">{errors.email}</span>
              )}
            </div>

            <div className="form-group">
              <label className="form-label fw-medium">Phone</label>
              <input
                className="form-control form-input"
                type="text"
                placeholder="Enter your phone number"
                name="phone"
                value={user.phone}
                onChange={handleChange}
              />
              {errors.phone && (
                <span className="text-danger">{errors.phone}</span>
              )}
            </div>

            <div className="form-group">
              <textarea
                className="form-control form-input"
                id="exampleFormControlTextarea1"
                placeholder="Please write your message in detail"
                name="description"
                value={user.description}
                onChange={handledescription}
              ></textarea>
              {errors.description && (
                <span className="text-danger">{errors.description}</span>
              )}
            </div>

            {errors.api && (
              <div className="text-danger fw-bold">{errors.api}</div>
            )}

            <button
              className="btn btn-rounded btn-dyo-primary"
              type="submit"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
